import React, { useEffect } from 'react';
import { Hero } from './components/Hero';
import { ProfessionalAudience } from './components/ProfessionalAudience';
import { StatsBar } from './components/StatsBar';
import { TestimonialStrip } from './components/TestimonialStrip';
import { Problems } from './components/Problems';
import { Modules } from './components/Modules';
import { ModuleIncludes } from './components/ModuleIncludes';
import { Comparison } from './components/Comparison';
import { Bonuses } from './components/Bonuses';
import { PricingPack } from './components/PricingPack';
import { Guarantee } from './components/Guarantee';
import { Reviews } from './components/Reviews';
import { CostOfNotBuying } from './components/CostOfNotBuying';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
type MetaPixel = ((...args: unknown[]) => void) & {
  callMethod?: (...args: unknown[]) => void;
  queue?: unknown[][];
  loaded?: boolean;
  version?: string;
  push?: MetaPixel;
};
declare global {
  interface Window {
    fbq?: MetaPixel;
    _fbq?: MetaPixel;
  }
}
const META_PIXEL_ID = '28816333964641291';
export function App() {
  useEffect(() => {
    if (window.fbq) {
      window.fbq('track', 'PageView');
      return;
    }
    const fbq: MetaPixel = (...args: unknown[]) => {
      if (fbq.callMethod) {
        fbq.callMethod.apply(fbq, args);
        return;
      }
      fbq.queue?.push(args);
    };
    if (!window._fbq) window._fbq = fbq;
    fbq.push = fbq;
    fbq.loaded = true;
    fbq.version = '2.0';
    fbq.queue = [];
    window.fbq = fbq;
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://connect.facebook.net/en_US/fbevents.js';
    document.head.appendChild(script);
    fbq('init', META_PIXEL_ID);
    fbq('track', 'PageView');
  }, []);
  return <main className="w-full overflow-x-hidden bg-mist font-sans text-navy antialiased" data-id="element-0" data-mp="su42lc18kscl">
      <noscript data-id="element-1" data-mp="3688dot76uy6">
        <img height="1" width="1" style={{
        display: 'none'
      }} src={`https://www.facebook.com/tr?id=${META_PIXEL_ID}&ev=PageView&noscript=1`} alt="" data-id="element-2" data-mp="35oy8u9shaup" />
      </noscript>
      <Hero data-id="element-3" data-mp="d4e94339pv1g" />
      <ProfessionalAudience data-id="element-4" data-mp="d4xopd5g47cb" />
      <StatsBar data-id="element-5" data-mp="d45tw4joadn3" />
      <TestimonialStrip data-id="element-6" data-mp="d2l8p5j9071w" />
      <Problems data-id="element-7" data-mp="85uihpdqbv2r" />
      <Modules data-id="element-8" data-mp="851hl51gbzsj" />
      <ModuleIncludes data-id="element-9" data-mp="86mgf6usu4w7" />
      <Comparison data-id="element-10" data-mp="86cmx9ajpflr" />
      <Bonuses data-id="element-11" data-mp="83qhbf77ta66" />
      <PricingPack data-id="element-12" data-mp="3gl4t5lvoq8m5" />
      <Guarantee data-id="element-13" data-mp="3gklau424hi7l" />
      <Reviews data-id="element-14" data-mp="3gm647qcpav3v" />
      <CostOfNotBuying data-id="element-15" data-mp="3glnzs6fvxakv" />
      <FAQ data-id="element-16" data-mp="3gj1qo2dcin0j" />
      <FinalCTA data-id="element-17" data-mp="3bmjqzgwvhev2" />
      <Footer data-id="element-18" data-mp="3bn2y02kziiub" />
    </main>;
}